import React, { memo } from 'react'
import { Link } from 'react-router-dom'

const StyledLink = ({ className = '', children, ...rest }) => {
  return (
    <Link className={`styled_link ${className}`} {...rest}>
      {children}
    </Link>
  )
}

export default memo(StyledLink)
